import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from 'assets/locales/en/translation.json';

const resource = {
  en: {
    translation: en,
  },
};

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    resources: resource,
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
